var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPriamryDarkBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 46.794,
    viewBox: "0 0 150 46.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#cc0028;}.d{fill:#bdab78;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1118.957 -668.353)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1482.42,888.774a4.915,4.915,0,1,0,4.663,4.92A4.791,4.791,0,0,0,1482.42,888.774Z",
    transform: "translate(-325.999 -200.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2389.547,1108.531a15.141,15.141,0,0,0,10.854-4.592q.658-.67,1.312-1.352c-3.25,1.332-6.536,2.55-9.808,3.633a15.671,15.671,0,0,1-4.928.8,15.211,15.211,0,0,1-6.708-1.558,15.412,15.412,0,0,0,5.461,2.589A15.585,15.585,0,0,0,2389.547,1108.531Z",
    transform: "translate(-1145.927 -394.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1342.414,746.022c0-.772-.63-1.016-1.605-1.016h-3.139v2.072h3.139C1341.724,747.078,1342.414,746.9,1342.414,746.022Z",
    transform: "translate(-198.705 -69.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2576.871,1081.382c.419-.113.836-.244,1.249-.4a14.217,14.217,0,0,0,7.723-6.723,15.713,15.713,0,0,1-2.244,1.207c-.236.1-.473.2-.709.3q-1.521,1.639-3.07,3.22A16.721,16.721,0,0,1,2576.871,1081.382Z",
    transform: "translate(-1324.545 -368.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2261.634,842.861a13.275,13.275,0,0,0-.529,1.71,12.994,12.994,0,0,0,1.87,10.394q.021-.474.071-.951c-.457-1.957-.866-3.882-1.219-5.761A18.025,18.025,0,0,1,2261.634,842.861Z",
    transform: "translate(-1037.33 -158.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1140.4,714.594c0-.945-.721-1.016-1.544-1.016h-2.987v2.042h2.987C1139.68,715.62,1140.4,715.549,1140.4,714.594Z",
    transform: "translate(-15.366 -41.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1334.951,888.518H1332.3v4.334h2.648c1.546,0,2.554-.867,2.554-2.179C1337.5,889.385,1336.5,888.518,1334.951,888.518Z",
    transform: "translate(-193.829 -200.024)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2628.3,735.5a15.365,15.365,0,0,1,3.087,5.979,15.532,15.532,0,0,0-.46-3.671,15.138,15.138,0,0,0-8.858-10.385q-1.121-.475-2.258-.923A101.756,101.756,0,0,1,2628.3,735.5Z",
    transform: "translate(-1363.554 -52.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2281.834,713.423q.286,1.527.621,3.093a130.516,130.516,0,0,1,3.515-13.533,15.37,15.37,0,0,1,6.414-8.3,16.725,16.725,0,0,0-10.55,18.74Z",
    transform: "translate(-1056.232 -23.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2324.63,684.344a14.333,14.333,0,0,0-23.246,6.23,131.472,131.472,0,0,0-3.78,14.873,14.339,14.339,0,0,0,18.594,16.362c4.342-1.437,8.709-3.113,12.981-4.98h0a14.318,14.318,0,0,0,5.274-22.268A100.383,100.383,0,0,0,2324.63,684.344Zm-14.661,27.478a7.838,7.838,0,1,1,7.779-7.826A7.795,7.795,0,0,1,2309.969,711.822Zm14.948,0c-3.069,0-4.874-1.218-5.857-2.695l2.085-1.945a4.591,4.591,0,0,0,3.819,1.874c1.64,0,2.554-.656,2.554-1.734,0-2.905-7.9-1.593-7.9-6.818,0-2.554,2.273-4.358,5.482-4.358a6.482,6.482,0,0,1,5.413,2.53l-2.015,1.992a4.374,4.374,0,0,0-3.515-1.757c-1.406,0-2.226.609-2.226,1.5,0,2.671,7.9,1.476,7.9,6.748C2330.658,709.877,2328.362,711.822,2324.918,711.822Z",
    transform: "translate(-1070.574 -11.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1342.13,714c0-.63-.417-.864-1.361-.864h-3.1v1.717h3.1C1341.713,714.852,1342.13,714.618,1342.13,714Z",
    transform: "translate(-198.705 -40.685)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2389.438,882.121a4.915,4.915,0,1,0,4.663,4.92A4.791,4.791,0,0,0,2389.438,882.121Z",
    transform: "translate(-1150.043 -194.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1129.407,868.918a5.663,5.663,0,0,1-2.53.586,4.914,4.914,0,0,1-.187-9.817,5.377,5.377,0,0,1,3.585,1.359l1.945-2.226a7.436,7.436,0,0,0-5.553-2.062,7.776,7.776,0,0,0-7.709,7.849,7.7,7.7,0,0,0,7.709,7.826,9.222,9.222,0,0,0,5.67-1.64v-6.115h-2.929Z",
    transform: "translate(0 -171.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1311.511,865.077c0-2.858-2.343-4.733-5.881-4.733h-5.342v15.019h2.929v-5.53h2.156l3.069,5.53h3.4l-3.491-5.975A4.454,4.454,0,0,0,1311.511,865.077Zm-5.646,2.179h-2.648v-4.334h2.648c1.546,0,2.554.867,2.554,2.156C1308.418,866.389,1307.411,867.256,1305.864,867.256Z",
    transform: "translate(-164.743 -174.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1451.471,856.758a7.838,7.838,0,1,0,7.779,7.849A7.8,7.8,0,0,0,1451.471,856.758Zm0,12.746a4.915,4.915,0,1,1,4.663-4.9A4.785,4.785,0,0,1,1451.471,869.5Z",
    transform: "translate(-295.05 -171.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1637.192,871.965l-3.023-11.621h-3.679l-3,11.621-3.3-11.621h-3.233l4.756,15.019h3.538l2.952-11.387,2.952,11.387h3.655l4.756-15.019H1640.5Z",
    transform: "translate(-456.076 -174.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1878.1,863.085h4.452v12.277h2.929V863.085h4.475v-2.741H1878.1Z",
    transform: "translate(-689.696 -174.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2040.824,866.319h-7.146v-5.975h-2.929v15.019h2.929v-6.3h7.146v6.3h2.952V860.344h-2.952Z",
    transform: "translate(-828.381 -174.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2251.921,815.761a13,13,0,0,1-1.87-10.394,13.314,13.314,0,0,1,.529-1.71,17.629,17.629,0,0,1,.924-3.948,14.358,14.358,0,0,0,.45,17.948A15.515,15.515,0,0,1,2251.921,815.761Z",
    transform: "translate(-1026.276 -119.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2545.183,1067.033c-.414.152-.831.284-1.249.4a16.22,16.22,0,0,1-3.316,1.619,15.6,15.6,0,0,0,4.954-.96,15.31,15.31,0,0,0,9.185-9.183,15.319,15.319,0,0,1-1.85,1.4A14.216,14.216,0,0,1,2545.183,1067.033Z",
    transform: "translate(-1291.607 -354.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2608.338,716.562a16.254,16.254,0,0,0-9.512-11.15q-2.509-1.062-5.081-2c.321.247.635.506.939.781q.728.657,1.445,1.331,1.135.45,2.258.923a15.138,15.138,0,0,1,8.858,10.385,15.532,15.532,0,0,1,.46,3.671,15.227,15.227,0,0,1,.468,4.655A16.375,16.375,0,0,0,2608.338,716.562Z",
    transform: "translate(-1339.876 -31.853)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2353.231,1094.006q1.549-1.578,3.07-3.22-1.276.55-2.561,1.079-.653.682-1.312,1.352a15.141,15.141,0,0,1-10.854,4.592,15.585,15.585,0,0,1-3.817-.479,15.412,15.412,0,0,1-5.461-2.589,15.706,15.706,0,0,1-3.472-2.324,15.9,15.9,0,0,1-1.359-1.353,16.287,16.287,0,0,0,10.016,7.357,16.721,16.721,0,0,0,4.1.514,16.157,16.157,0,0,0,8.7-2.542A16.732,16.732,0,0,0,2353.231,1094.006Z",
    transform: "translate(-1097.954 -383.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2269.567,691.988c.352,1.879.761,3.8,1.219,5.761.049-.468.118-.937.21-1.407.1-.493.2-.981.3-1.468q-.334-1.564-.621-3.093a16.724,16.724,0,0,1,10.55-18.74,15.5,15.5,0,0,1,4.27-1.873q.691-.186,1.388-.306a17.787,17.787,0,0,0-17.507,15.734A18.025,18.025,0,0,0,2269.567,691.988Z",
    transform: "translate(-1045.07 -2.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2327.243,688.651a15.365,15.365,0,0,0-3.087-5.979,101.756,101.756,0,0,0-8.489-9q-.718-.673-1.445-1.331c-.3-.274-.618-.533-.939-.781a15.4,15.4,0,0,0-12.059-2.978q-.7.121-1.388.306a15.4,15.4,0,0,0-10.684,10.174,130.456,130.456,0,0,0-3.515,13.533c-.1.488-.2.975-.3,1.468-.092.469-.161.939-.21,1.407q-.05.477-.071.951a15.418,15.418,0,0,0,.032,1.9,15.219,15.219,0,0,0,3.833,8.959,15.885,15.885,0,0,0,1.359,1.353,15.706,15.706,0,0,0,3.472,2.324,15.212,15.212,0,0,0,6.708,1.558,15.668,15.668,0,0,0,4.928-.8c3.272-1.083,6.559-2.3,9.808-3.633q1.285-.527,2.561-1.08c.236-.1.473-.2.709-.3a15.713,15.713,0,0,0,2.244-1.207,15.277,15.277,0,0,0,6.6-9.4,15.734,15.734,0,0,0,.4-2.776A15.227,15.227,0,0,0,2327.243,688.651Zm-1.026,7.172a14.2,14.2,0,0,1-8.2,9.838h0c-4.272,1.868-8.639,3.543-12.981,4.98a14.339,14.339,0,0,1-18.594-16.362,131.472,131.472,0,0,1,3.78-14.873,14.255,14.255,0,0,1,9.906-9.432,14.309,14.309,0,0,1,13.341,3.2,100.383,100.383,0,0,1,9.823,10.216A14.162,14.162,0,0,1,2326.217,695.824Z",
    transform: "translate(-1059.413 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2358.49,850.1a7.838,7.838,0,1,0,7.779,7.849A7.8,7.8,0,0,0,2358.49,850.1Zm0,12.746a4.915,4.915,0,1,1,4.663-4.9A4.785,4.785,0,0,1,2358.49,862.851Z",
    transform: "translate(-1119.095 -165.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2538.589,854.369c0-.89.82-1.5,2.226-1.5a4.374,4.374,0,0,1,3.515,1.757l2.015-1.992a6.482,6.482,0,0,0-5.413-2.53c-3.21,0-5.482,1.8-5.482,4.358,0,5.225,7.9,3.913,7.9,6.818,0,1.078-.914,1.734-2.554,1.734a4.591,4.591,0,0,1-3.819-1.874l-2.085,1.945c.984,1.476,2.788,2.695,5.857,2.695,3.444,0,5.74-1.945,5.74-4.663C2546.485,855.845,2538.589,857.04,2538.589,854.369Z",
    transform: "translate(-1286.401 -165.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1121.544,704.551h2.672c1.25,0,3.3,0,3.3-2.255s-2.052-2.265-3.3-2.265H1120.1v7.385h1.442Zm0-3.281h2.987c.823,0,1.544.071,1.544,1.016s-.721,1.026-1.544,1.026h-2.987Z",
    transform: "translate(-1.04 -28.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1222.68,700.03h-1.443v4.114c0,1.219-.437,2.215-2.479,2.215s-2.479-1-2.479-2.215V700.03h-1.443v4.216c0,2.377,1.514,3.352,3.921,3.352s3.921-.975,3.921-3.352Z",
    transform: "translate(-87.109 -28.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1329.531,705.272a1.974,1.974,0,0,0-1.138-1.818,1.606,1.606,0,0,0,.853-1.534c0-1.4-1.158-1.89-2.9-1.89H1321.9v7.385h4.724C1328.424,707.416,1329.531,706.664,1329.531,705.272Zm-6.187-4.043h3.1c.945,0,1.361.234,1.361.863s-.417.853-1.361.853h-3.1Zm0,4.988v-2.072h3.139c.975,0,1.605.244,1.605,1.016,0,.874-.691,1.056-1.605,1.056Z",
    transform: "translate(-184.38 -28.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1429.653,706.136H1424.3V700.03h-1.443v7.385h6.8Z",
    transform: "translate(-276.099 -28.779)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.442,
    height: 7.385,
    transform: "translate(1154.957 671.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1548.87,705.783c3.393,0,3.982-1.991,4.124-2.814h-1.443a2.465,2.465,0,0,1-2.57,1.575,2.536,2.536,0,0,1-2.814-2.591c0-1.534.853-2.682,2.9-2.682a2.336,2.336,0,0,1,2.377,1.3h1.443c-.112-.4-.6-2.54-3.9-2.54-2.936,0-4.287,1.605-4.287,3.759C1544.695,704.483,1546.534,705.783,1548.87,705.783Z",
    transform: "translate(-386.792 -26.964)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.442,
    height: 7.385,
    transform: "translate(1167.769 671.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1689.121,704.544c-1.951,0-2.5-.782-2.763-1.321l-1.392.437c.173.559.945,2.123,4.114,2.123,1.971,0,3.637-.65,3.637-2.4,0-1.239-.975-1.879-2.631-2.133l-1.747-.264c-1.473-.183-1.656-.518-1.656-.833,0-.681.985-.924,1.961-.924,1.757,0,2.357.569,2.59,1.229l1.361-.447c-.183-.508-.731-1.981-3.911-1.981-.569,0-3.444,0-3.444,2.215,0,1.128.955,1.869,2.662,2.1l1.768.244c1.056.132,1.6.447,1.6.924C1691.275,704.158,1690.3,704.544,1689.121,704.544Z",
    transform: "translate(-514.231 -26.964)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPriamryDarkBg);
export default __webpack_public_path__ + "static/media/logo-Priamry-Dark-bg.d58d80546fc6dc2988bda3226e62e24c.svg";
export { ForwardRef as ReactComponent };